<template>
    <div class="auth-bg overflow-auto">
        <router-view/>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
    
})
</script>

<style scoped>
.auth-bg {
  background-image: url('../assets/new-auth-background.png');
  background-repeat: no-repeat;
  background-size: cover;
  position:fixed;
  background-position: right;
  left:0;right:0;top:0;bottom:0;
}
</style>